<div class=" mt-4">



  <section class="my-4">




    <div class="scrollmenu">

      <a [routerLink]="['/PayOut/PayoutReports']">Payout Reports</a>


      <a [routerLink]="['/PayOut/PayoutPostback']">PayOut Webhook Url</a>

      <a  [routerLink]="['/PayOut/Payoutwebhookdata']">PayOut Webhook Data</a>

      <a class="active menu" [routerLink]="['/PayOut/PayoutLedger']">PayOut Ledger</a>
    </div>

  </section>

  <section>


    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">


          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportTransactionData()">Excel</a></li>

            </ul>
          </div>
          <button class="dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i>
            Filter</button>


        </div>
      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last top 100 records. For more details please click on
          Filter</small>
      </div>

    </div>
    <div class="row  my-4" *ngIf="filtering">
      <div class=" col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>
          <div class="col-md-12">
            <!-- filtering starts -->
            <form>

              <div class="row m-0">
                <div class="col-md-3 mt-4">
                  <div class="form-group">
                    <label class="customlabel">Payout Processor</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="PayoutProcessorlist" id="PayoutProcessor" placeholder="PayoutProcessor" [formControl]="PayoutProcessor"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel"> Date</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange"
                        (ngModelChange)="checkRangeType()" required>
                      </ngx-select>
                    </div>

                  </div>

                </div>

                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel">From Date</label>
                    <input class="formcontrol-user1 form-control" type="date" class="form-control"
                      placeholder="From Date" id="fromdate" [formControl]="fromdate" max="{{datePickerMaxDate}}"
                      (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel">To Date</label>
                    <input class="formcontrol-user1 form-control" type="date" class="form-control" placeholder="To Date"
                      id="todate" [formControl]="todate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                  </div>
                </div>
                <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should
                  not be greater than To
                  Date</span>

              </div>

            </form>
          </div>




          <div class="col-md-12 text-right">
            <div class=" text-right  " *ngIf="!isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>





            <div class=" text-right  " *ngIf="isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row table-bordered' (columnMode)="'Force'" [footerHeight]="50"
          [scrollbarH]="true" [rowHeight]="'auto'"[columnMode]="'force'" [limit]="10" [rows]="rows" >

          <ngx-datatable-column class="blue-bg" name="TransactionId" [width]="320">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">
                {{row.TransactionId}}
              </div>
            </ng-template>
          </ngx-datatable-column>



          <ngx-datatable-column name="Transaction Type" [width]="350">
            <ng-template let-row="row" ngx-datatable-cell-template>

              {{row.TransactionType}}
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Total Amount" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>

              {{row.Amount}}
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Updated DateTime" [width]="320">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.UpdatedDatetime | date:'d/M/yy, h:mm a'}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Balance" [width]="320">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountBalance}}
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
      </div>
    </div>
  </section>
</div>
